import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApprovalDetails } from '../models/approvalDetails.model';
import { ApprovalRequest } from '../models/approvalRequest.model';
import { FrequencyType } from '../models/FrequencyType.model';
import { Reminder } from '../models/reminder';
import { PageResult } from '../shared/models/pageResult';
import { environment } from 'src/environment';
import { Observable, of } from 'rxjs';
import { FilterItemList, SelectedFilter } from '../shared/models/filter.model';

@Injectable({
  providedIn: 'root'
})
export class RemindersApiService {

  #httpservice = inject(HttpClient);
  #baseUrl = environment.apiUrl;
  #specBaseUrl = `${this.#baseUrl}/reminder`

  create = (reminder: Reminder) => this.#httpservice.post<Reminder>(`${this.#specBaseUrl}/create`, reminder);
  update = (reminder: Reminder) => this.#httpservice.post<Reminder>(`${this.#specBaseUrl}/update`, reminder);

  getFrequencyType = () => this.#httpservice.get<FrequencyType[]>(`${this.#specBaseUrl}/getFrequencyType`);
 
  getRemindersForExtra = (page: number, selectedFilter: SelectedFilter) => {
    return this.#httpservice.post<PageResult<Reminder>>(`${this.#specBaseUrl}/getRemindersForExtra`, { paging: page, selectedFilter });
  }
  getReminders = (page: number, selectedFilter: SelectedFilter) => {
    return this.#httpservice.post<PageResult<Reminder>>(`${this.#specBaseUrl}/getReminders`, { paging: page, selectedFilter });
  }
  deleteReminderById = (id: number) => {
    return this.#httpservice.get<Reminder>(`${this.#specBaseUrl}/deleteById/${id}`);
  }
  getMailToApprovalByGuid = (approvalRequest: ApprovalRequest, guid: any) => {
    return this.#httpservice.post<ApprovalDetails>(`${this.#specBaseUrl}/getApprovalDeatails/${guid}`, approvalRequest)
  };
  approval = (approvalRequest: ApprovalRequest, guid: any) => {
    return this.#httpservice.post<boolean>(`${this.#specBaseUrl}/approval/${guid}`, approvalRequest)
  };
  sendReminder = (id: number) => {
    return this.#httpservice.get<boolean>(`${this.#specBaseUrl}/sendReminder/${id}`)
  };

  getFilterItemList(): Observable<FilterItemList[]> {
    const res: FilterItemList[] =
        [    
            {
                "id": 2,
                "displayNameEn": "Distribution date",
                "displayNameHe": "תאריך הפצה",
                "fieldName": "startDate",
                "typeFilter": 1
            },
            {
                "id": 3,
                "displayNameHe": "יוצר השאלון",
                "displayNameEn": "Questionnaire creator",
                "fieldName": "creator",
                "typeFilter": 1
            },
        ];
    return of(res);
}
}
